module.exports = __webpack_public_path__ + "media/src/assets/images/beauport-logo-8832d4606d1dd8823400fcbd2b67aac5.png";